import Img404 from "../assets/images/404.webp";
import { useNavigate } from "react-router-dom";
import { HOME } from "../routes/app/paths";

const Page404 = () => {
  const navigate = useNavigate();

  const redirect = () => {
    navigate(HOME);
  };

  
  return (
    <>
      <div className="flex flex-col justify-center items-center gap-3 p-10">
        {/* image */}
        <div className="flex flex-col justify-center items-center -mb-8">
          <img src={Img404} alt="404" className="w-80 mt-11 md:mt-5 z-10" />
          <h1 className="text-[150px] font-bold text-blue-primary -mt-32">
            404
          </h1>
        </div>

        {/* text */}
        <h1 className="text-5xl font-bold text-blue-primary">¡Ups!</h1>
        <span className="text-xl font-semibold text-blue-primary">
          La página que buscas no está disponible
        </span>
        
        <span className="text-xl font-semibold text-blue-primary text-center my-7">
          Asegúrese de haber escrito correctamente la URL.<br/>
          Si persiste el problema, por favor contacte con nuestro <strong className="cursor-pointer underline-offset-4 hover:underline">soporte técnico</strong>.
        </span>

        {/* button */}
        <button className="flex gap-4 justify-center items-center py-2 px-5 rounded-full text-white bg-blue-primary text-xl font-semibold"
          onClick={redirect}
        >
          Regresar
        </button>
      </div>
    </>
  );
};
export default Page404;
